module.exports = __webpack_public_path__ + "static/media/main.cbe2018d.png";